import React from 'react';
import logo from '../logo.svg';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { useEffect, useState } from 'react'
import ReactModal from 'react-modal';
import { useNavigate } from "react-router-dom";
import { getCokie, isAuth, signout } from "../helpers/auth";
ReactModal.setAppElement('*'); // suppresses modal-related test warnings.




const Blogs = () => {
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [curse, setCurso] = useState();
  const navigate = useNavigate()

  function openModal() {
    setIsOpen(true);
  }

  // function afterOpenModal() {
  //   // references are now sync'd and can be accessed.
  //   subtitle.style.color = '#f00';
  // }

  function closeModal() {
    setIsOpen(false)
  }

  const [selectedYear, setSelectedYear] = useState({ value: '2025', label: '2025' });
  const [selectedMencion, setSelectedMencion] = useState({ value: 'P', label: 'P' });
  const [selectedOption, setSelectedOption] = useState({ value: '3', label: '3' });
  // const [options, setOptions] = useState()
  const [www, setWww] = useState()
  const [calification, setCalification] = useState()
  const [Userstv, setUserstv] = useState()
  const [Curses, setCurses] = useState()
  const token = getCokie("token");
  useEffect(() => {

    if (localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).rol == '2') { get() }
    if (localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).rol == '3') { getstdcurses() }
    if (localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).rol == '3') { getstdcalifications() }
  }, []);

  const get = () => {
    fetch(`${process.env.REACT_APP_URL}/api/curses/cursosespecificos/${JSON.parse(localStorage.getItem("user"))._id}/true`)
      .then((response) => response.json())
      .then((www) => {
        console.log(www)
        if (!www.error) { setWww(www[0].curses) } else {
          signout()
          navigate('/contacto')
        }
      })
  }

  const getstdcurses = () => {
    fetch(`${process.env.REACT_APP_URL}/api/curses/stdcurses/${JSON.parse(localStorage.getItem("user"))._id}/E/1`)
      .then((response) => response.json())
      .then((www) => {
        if (!www.error) { setWww(www.length === 0 ? [] : www[0].curses) } else {
          signout()
          navigate('/contacto')
        }
      })
  }


  const getstdcalifications = async () => {
    fetch(`${process.env.REACT_APP_URL}/api/users/stdnotes/${JSON.parse(localStorage.getItem("user"))._id}`)
      .then((response) => response.json())
      .then((www) => {
        setCalification(www)
        var ciclos = []
        for (var i = 0; i < www.length; i++) {
          ciclos.push({ value: www[i]._id, label: www[i]._id })
        }
        // setOptions(ciclos)
        // console.log(www)
        // setSelectedOption({ value: www[www.length - 1]._id, label: www[www.length - 1]._id })
      });
  }


  const sendEncuesta = async (e) => {
    e.preventDefault()
    console.log("w1w")
    setIsOpen(false)
  }


  // const wwdelete = (item) => {
  //   return fetch(process.env.REACT_APP_URL + '/api/curses/' + item, {
  //     method: 'delete'
  //   })
  //     .then(response => response.json())
  //     .then(data => { toast.warning(data); getstdcurses() })
  // }

  const Sencitive = (item) => {
    console.log(item)
    if (item.length > 2) {
      fetch(process.env.REACT_APP_URL + '/api/users/Stv', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          www: item
        })
      })
        .then(response => response.json())
        .then(data => { setUserstv(data); console.log(data) })
        .catch(error => console.error(error))
    }
  }

  const SencitiveCurses = (item) => {
    console.log(item)
    if (item.length > 2) {
      fetch(process.env.REACT_APP_URL + '/api/curses/cursossensitive', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          www: item
        })
      })
        .then(response => response.json())
        .then(data => { setCurses(data); console.log(data) })
        .catch(error => console.error(error))
    }
  }


  const createCurse = (mencion, ciclo, codigo, title, credito, requisito) => {
    console.log(mencion, ciclo, codigo, title, credito, requisito)
    if (www.title !== title)
      // if (mencion === 'www') {
      fetch(process.env.REACT_APP_URL + '/api/curses', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          title: title,
          description: 'String',
          img: 'String',
          especialidad: mencion,
          mencion: mencion,
          credito: credito,
          ciclo: ciclo,
          meet: 'String',
          show: 'true',
          codigo: codigo,
          requisito: requisito,
          year: new Date().getFullYear(),
          user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user"))._id : '63ab4f45a06c6fe92e7a4209',
          userteacher: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user"))._id : '63ab4f45a06c6fe92e7a4209',
        })
      })
        .then(response => response.json())
        .then(data => { toast.info(data); get() })
        .catch(error => console.error(error))
    // }
  }

  const deleteCurse = (item) => {
    const response = window.confirm('Deseas eliminar este archivo?');
    if (response) {
      return fetch(process.env.REACT_APP_URL + '/api/curses/' + item, {
        method: 'delete'
      })
        .then(response => response.json())
        .then(data => { toast.warning(data); get() })
    }
  }



  const listItems = www ? www.map((number) =>
    <div style={{ backgroundColor: 'white', padding: '.1cm', width: '9cm', color: 'black' }} key={number._id}>
      <div style={{ alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', display: 'flex' }}>
        <Link style={{ color: 'white', padding: '7px 16px', textAlign: 'center', width: '100%', background: 'slateblue', borderRadius: '.2cm' }} to={'/curso/' + number._id} onClick={() => localStorage.setItem('curse', number._id)} >
          {number.title} {number.mencion} {number.ciclo} {number.year} {number.codigo}
        </Link>
      </div>
      <button onClick={() => deleteCurse(number._id)}>errase</button>
    </div>
  ) : <header className="App-header">
    <img src={logo} className="App-logo" alt="logo" />
  </header>


  const listCurse = Curses ? Curses.map((number) =>
    <div style={{ backgroundColor: 'wheat', padding: '.1cm', margin: '.2cm', padding: '.2cm', width: '9cm', width: '9cm', color: 'black', borderRadius: '.1cm' }} key={number._id}>
      <div style={{ alignItems: 'center', textAlign: 'center' }}>
        <div>
          {number.title}
          {number._id}
        </div>
        <div>
          {number.codigo} - {number.mencion} - {number.ciclo}
        </div>
        <button onClick={() => createCurse(number.mencion, number.ciclo, number.codigo, number.title, number.credito, number.requisito)}>
          Generar Curso
        </button>
      </div>
    </div>
  ) : ''


  return (
    <div className="contenedor" >
      <ToastContainer
        position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false}
      />
      <>
        <button onClick={() => createCurse("number.mencion", "number.ciclo", "number.codigo", "number.title", "number.credito", "number.requisito")}>
          Generar Vol
        </button>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>{www != [] ? listItems : ""}</div>
        <input style={{ padding: '.6em', boxSizing: 'border-box', fontSize: 'inherit', width: '100%', marginBottom: '.5em' }} placeholder="Nombre o curso mínimo tres letras inciales" onChange={e => SencitiveCurses(e.target.value)} />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>{listCurse}</div>

      </>



    </div>
  )
}

export default Blogs

// export default App